/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes, { oneOf } from 'prop-types';
import { Accordion, AccordionTab } from '@lmig/lmds-react-accordion';
import css from 'styled-jsx/css';

const getBgColorStyles = color => {
  switch (color) {
    case 'atmosphericGray':
    case 'coolWhite':
      return css.resolve`
        @import './global-styles/tokens';

        .lmig-Accordion {
          background-color: $lm-color-background-atmospheric;
        }
      `;
    case 'lightLibertyTeal':
      return css.resolve`
        @import './global-styles/tokens';

        .lmig-Accordion {
          background-color: #f2fcfc;
        }
      `;
    case 'libertyBlue':
      return css.resolve`
        @import './global-styles/tokens';

        .lmig-Accordion {
          background-color: #1a1446;
        }
      `;
    case 'libertyYellow':
      return css.resolve`
        @import './global-styles/tokens';

        .lmig-Accordion {
          background-color: #ffd000;
        }
      `;
    case 'white':
      return css.resolve`
        @import './global-styles/tokens';

        .lmig-Accordion {
          background-color: #ffffff;
        }
      `;
    default:
      return { className: '', styles: '' };
  }
};

const AccordionChildren = ({
  align = 'center',
  as = 'h3',
  accordionStyle = 'standard',
  noBorderTop = false,
  backgroundColor = '',
  children, ...rest }) => {
  const { className: bgColorClass, styles: bgColorStyles } = getBgColorStyles(backgroundColor);

  return (
    <div className="outerWrapper">
      <Accordion as={as} variant={accordionStyle} noBorderTop={noBorderTop} className={bgColorClass} {...rest}>
        {children}
      </Accordion>
      {bgColorStyles}
      <style jsx>
        {`
          @import './global-styles/tokens';
          .outerWrapper {
            width: 100%;
            ${align === 'left' ? 'margin: 0' : 'margin: 0 auto'}
            @media screen and (min-width: $lm-breakpoint-md-min) {
              max-width: 47.75rem;
            }
          }
        `}
      </style>
    </div>
  );
}

AccordionChildren.propTypes = {
  align: PropTypes.string,
  as: PropTypes.string,
  noBorderTop: PropTypes.bool,
  accordionStyle: PropTypes.string,
  children: PropTypes.node.isRequired,
  backgroundColor: oneOf(['', 'white', 'coolWhite', 'atmosphericGray', 'lightLibertyTeal', 'libertyBlue', 'libertyYellow']),
};


AccordionChildren.contentRender = ({ items, ...rest }, { componentMap, Render }) => (
  <AccordionChildren {...rest}>
    {items.map(({ title, children }) => (
      <AccordionTab labelVisual={title} key={`accordion-tab-${title}`}>
        <Render componentMap={componentMap} content={children} />
      </AccordionTab>
    ))}
  </AccordionChildren>
);

export default AccordionChildren;
